export default __webpack_public_path__ + "src/images/loading_font_blue-861082.png";